<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">Qeydiyyat</h2>

    <!-- Registration Form -->
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-group">
        <label for="name">Ad</label>
        <input
          type="text"
          id="name"
          formControlName="name"
          placeholder="Ad daxil edin"
          [class.invalid]="registerForm.get('name')?.invalid && registerForm.get('name')?.touched"
        >
        <div class="error-message" *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
          <span>Ad daxil edilməlidir.</span>
        </div>
      </div>

      <div class="form-group">
        <label for="phoneNumber">Telefon nömrəsi</label>
        <input
          type="text"
          id="phoneNumber"
          formControlName="phoneNumber"
          placeholder="+994 (0XX) XXX-XX-XX"
          (input)="onPhoneInput($event)"
          [class.invalid]="registerForm.get('phoneNumber')?.invalid && registerForm.get('phoneNumber')?.touched"
        >
        <div class="error-message" *ngIf="registerForm.get('phoneNumber')?.invalid && registerForm.get('phoneNumber')?.touched">
          <span *ngIf="registerForm.get('phoneNumber')?.errors?.['required']">Telefon nömrəsi daxil edilməlidir.</span>
          <span *ngIf="registerForm.get('phoneNumber')?.errors?.['pattern']">Düzgün operator daxil etməmisiniz.</span>
        </div>
      </div>


      <div class="form-group">
        <label for="password">Şifrə</label>
        <div class="password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            placeholder="********"
            [class.invalid]="registerForm.get('password')?.invalid && registerForm.get('password')?.touched"
          >
          <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
            <i class="icon" [class.icon-show]="!showPassword" [class.icon-hide]="showPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
          <span *ngIf="registerForm.get('password')?.errors?.['required']">Şifrə daxil edilməlidir.</span>
          <span *ngIf="registerForm.get('password')?.errors?.['minlength']">Şifrə ən azı 6 simvol olmalıdır.</span>
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Şifrənin təsdiqi</label>
        <div class="password-wrapper">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="********"
            [class.invalid]="(registerForm.get('confirmPassword')?.invalid || registerForm.hasError('mismatch')) && registerForm.get('confirmPassword')?.touched"
          >
          <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
            <i class="icon" [class.icon-show]="!showConfirmPassword" [class.icon-hide]="showConfirmPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="(registerForm.get('confirmPassword')?.invalid || registerForm.hasError('mismatch')) && registerForm.get('confirmPassword')?.touched">
          <span *ngIf="registerForm.get('confirmPassword')?.errors?.['required']">Şifrə təsdiqi daxil edilməlidir.</span>
          <span *ngIf="registerForm.hasError('mismatch') && !registerForm.get('confirmPassword')?.errors?.['required']">Şifrələr uyğun gəlmir.</span>
        </div>
      </div>

      <button type="submit" class="btn-submit" [disabled]="registerForm.invalid">Qeydiyyatdan keç</button>

      <div class="auth-links">
        <span>Artıq hesabın var? <a [routerLink]="['/login']">Daxil ol</a></span>
      </div>

      <div class="legal-notice">
        Davam etməklə, siz <a href="#">İstifadəçi razılaşmasını</a> və <a href="#">Qaydaları</a> ilə razı olduğunuzu təsdiq edirsiniz.
      </div>
    </form>
  </div>
</div>
